// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","widget":"true-fit_widget__nyvZE"};